import { Controller } from "@hotwired/stimulus"

// Auto-growing composer textarea: grows with content up to the CSS max-height (then scrolls), and
// submits its form on Enter (Shift+Enter inserts a newline). Used by the shared `message_input`
// partial so every standardized composer behaves like a chat box.
export default class extends Controller {
  connect() {
    this.resize()
  }

  resize() {
    const el = this.element
    el.style.height = "auto"
    el.style.height = `${el.scrollHeight}px`
  }

  keydown(event) {
    if (event.key === "Enter" && !event.shiftKey && !event.isComposing) {
      event.preventDefault()
      const form = this.element.form
      if (!form) return
      if (form.requestSubmit) {
        form.requestSubmit()
      } else {
        form.submit()
      }
    }
  }
}
